import {useEffect, useState} from 'react';

// 会員登録訴求モーダルを表示するスクロール量(px)
const SIGN_UP_APPEAL_SCROLL_THRESHOLD = 300;

type UseSignUpAppealOnScrollArgs = {
  isValid: boolean;
  setIsOpened: (opened: boolean) => void;
};

export const useSignUpAppealOnScroll = ({
  isValid,
  setIsOpened,
}: UseSignUpAppealOnScrollArgs) => {
  const [hasShownSignUpAppeal, setHasShownSignUpAppeal] = useState(false);

  useEffect(() => {
    if (isValid || hasShownSignUpAppeal) {
      return;
    }
    const handleScroll = () => {
      if (window.scrollY >= SIGN_UP_APPEAL_SCROLL_THRESHOLD) {
        setIsOpened(true);
        setHasShownSignUpAppeal(true);
      }
    };
    // スクロール復元等で初期位置が閾値を超えている場合に備え、初回も判定する
    handleScroll();
    window.addEventListener('scroll', handleScroll, {passive: true});
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isValid, hasShownSignUpAppeal, setIsOpened]);
};
